import { defineMessages } from "react-intl";

const PREFIX = "RecentlyFavourites";
export default defineMessages({
  headerLabel: {
    id: `${PREFIX}.header.label`,
    defaultMessage: "Recently saved in Favourites",
  },
  headerMore: {
    id: `${PREFIX}.header.more`,
    defaultMessage: "More favourites",
  },
  dateLastOpened: {
    id: `${PREFIX}.content.date.lastOpened`,
    defaultMessage: "Last opened:",
  },
});
